import { render } from "./SectionBorder.vue?vue&type=template&id=64cf2802"
const script = {}

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__